import {AppType} from './app';

export type TRoundingRules = Array<{
  min: number;
  text: string;
}>;

export const YANDEX_AD_MODES = [
  'none',
  'banner',
  'floor_ad',
  'floor_ad_closed',
  'floor_ad_banner',
  'floor_ad_closed_copy',
] as const;

export const SSP_AD_MODES = [
  'none',
  'ssp_floor_ad',
  'ssp_floor_ad_closed',
] as const;

export const SSP_PARTNER_AD_MODES = ['none', 'ssp_floor_ad_partner'] as const;

export const WEB_AUTO_LOGIN = ['none', 'snackbar', 'headerAvatar'] as const;

export const NEW_MAIN_PAGE_BLOCK_TYPES = [
  /** подборка, где приложения показываются в виде карточек со скриншотами */
  'selection_with_app_cards',
  /** топ игр/приложений */
  'top_apps',
  /** подборка, где приложения показываются в виде простого списка */
  'selection_with_app_list',
  /** блок со ссылками на подборки */
  'selection_cards',
  /** блок со статьями простора */
  'articles',
  /** блок с событиями */
  'events',
] as const;

export type YandexAdMode = (typeof YANDEX_AD_MODES)[number];
export type SSPAdMode = (typeof SSP_AD_MODES)[number];
export type SspPartnerAdMode = (typeof SSP_PARTNER_AD_MODES)[number];
export type AutologinMode = (typeof WEB_AUTO_LOGIN)[number];
export type NewMainPageBlockType = (typeof NEW_MAIN_PAGE_BLOCK_TYPES)[number];
export type NewMainPageBlocksOrderConfig = Record<
  AppType,
  Array<NewMainPageBlockType>
>;
